import axios from "axios";

export const getNotifications = (token, clientId) => {
  const requestUrl = `/organization/notification`;

  let filter = [];
  let sort = [];

  filter.push({
    property: "appName",
    value: "POWERTEAM",
    operator: "eq"
  });

  sort.push({
    property: "createdAt",
    dir: "desc"
  });

  let params = {
    access_token: token,
    limit: 5
  };

  if (clientId) {
    params.organization_id = clientId;
  }

  params.sort = JSON.stringify(sort);
  params.filter = JSON.stringify(filter);

  return axios.get(requestUrl, { params });
};

export const readWebNotification = (token, notificationId) => {
  const requestUrl =
    `/organization/notification-user/mark-notification-as-read/` +
    notificationId;
  var formData = new FormData();
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/TamtamAPI/notifications.js